import { getGATrackingId, getIsUserAdmin, getUserAccess } from '@app/ducks';
import React from 'react';
import { useSelector } from 'react-redux';

import { GA4Event, GA4EventParams, pushGTMEvent } from './gtm';
import { getStoredUTMParams } from './utm';

export const useGTM = () => {
  const isUserAdmin = useSelector(getIsUserAdmin);
  const userAccess = useSelector(getUserAccess);
  const clientTrackingId = useSelector(getGATrackingId);

  const userType = isUserAdmin ? 'admin' : userAccess;

  const trackGTMEvent = React.useCallback(
    <T extends GA4Event>(event: T, params: GA4EventParams[T]) => {
      const utm = getStoredUTMParams();
      pushGTMEvent(event, {
        ...params,
        ...utm,
        clientTrackingId,
        visitorType: userType,
      });
    },
    [userType, clientTrackingId],
  );

  return {
    trackGTMEvent,
  };
};
